import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";
import PolicyPage from "./PolicyPage";

export default function Returns() {
    const { t } = useTranslation();
    const intro = t("returns.template.intro");
    const fields = t("returns.template.fields", { returnObjects: true });

    // Opens the customer's email app with the template filled in.
    const mailto =
        "mailto:info@eufy.ge" +
        `?subject=${encodeURIComponent(t("returns.template.subject"))}` +
        `&body=${encodeURIComponent([intro, "", ...fields].join("\n"))}`;

    return (
        <PolicyPage name="returns">
            <Row>
                <h3 className="text-xl mt-4 mb-2">{t("returns.template.title")}</h3>
                <div>
                    <div className="rounded-2xl bg-[#f5f6f7] px-[20px] py-[16px]">
                        <p className="mb-2">{intro}</p>
                        {fields.map((field) => (
                            <p key={field}>{field}</p>
                        ))}
                    </div>
                </div>
                <div>
                    <a href={mailto} className="btn eufy-button mt-3">
                        {t("returns.template.button")}
                    </a>
                </div>
            </Row>
        </PolicyPage>
    );
}
